import { ZocNode } from "@/core/battle/ai/types/ai.types";
import { BattleUnit, Hex } from "@/core/types/battle.types";
import { getAxialNeighbors, coordsToId } from "@/core/utils/hex.utils"; // Твої утиліти

export class ZocCalculator {
    public static calculate(
        enemies: BattleUnit[], 
        battleMap: Map<string, Hex>
    ): Map<string, ZocNode> {
        const zocMap = new Map<string, ZocNode>();

        for (const enemy of enemies) {
            if (enemy.isDead) continue;

            // Середня шкода одного ворога
            const avgDmg = (enemy.stats.damageMin + enemy.stats.damageMax) * enemy.count / 2;
            const neighbors = getAxialNeighbors(enemy.q, enemy.r);
            const enemyId: string = enemy.unitId;

            for (const neighborCoords of neighbors) {
                const hexId = coordsToId(neighborCoords);
                const hex = battleMap.get(hexId);

                if (hex && !hex.isObstacle) {
                    const node = zocMap.get(hexId) || { totalThreat: 0, attackersCount: 0, attackersIds: [] };
                    
                    zocMap.set(hexId, {
                        totalThreat: node.totalThreat + avgDmg,
                        attackersCount: node.attackersCount + 1,
                        attackersIds: [...node.attackersIds, enemyId]
                    });
                }
            }
        }

        return zocMap;
    }
}